import { Route, Routes } from 'react-router-dom';
import { Flex } from '../styled-system/jsx';
import { AsyncCollectionsPage } from './collections/components/AsyncCollectionsPage';
import { LeftNav } from './leftNav/components/LeftNav';
import { ConfirmContextProvider } from './ui/modals/confirm/context/ConfirmContext';
import { AsyncModelsPage } from './models/components/AsyncModelsPage';

export const App = () => {
  return (
    <Flex grow="1">
      <ConfirmContextProvider>
        <LeftNav />
        <Flex alignItems="flex-start" justifyContent="center" grow="1">
          <Routes>
            <Route element={<AsyncCollectionsPage />} path="collections/*" />
            <Route element={<AsyncModelsPage />} path="models/*" />
          </Routes>
        </Flex>
      </ConfirmContextProvider>
    </Flex>
  );
};
